module.exports = __webpack_public_path__ + "static/media/warn-circle.9fc4c66b.svg";